import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {FabricService} from 'src/app/services/fabric/fabric.service';

const SERVICE_NAME = 'mgmt-privateendpoint-resources';


@Injectable({
  providedIn: 'root'
})
export class PrivateEndpointsService {

  constructor(private fabricService: FabricService) {}

  getPrivateEndpoints(tenantId, dataZone): Observable<any> {
    return this.fabricService.invokeOperation<any>(SERVICE_NAME, 'get_mgmt_tenants_tenantid_pe-connections', {tenantId, dataZone});
  }

  approvePrivateEndpoints(data): Observable<any> {
    return this.fabricService.invokeOperation<any>(SERVICE_NAME, 'put_mgmt_tenants_tenantid_pe-connections_id_approve', data);
  }

  rejectPrivateEndpoints(data): Observable<any> {
    return this.fabricService.invokeOperation<any>(SERVICE_NAME, 'put_mgmt_tenants_tenantid_pe-connections_id_reject', data);
  }

  deletePrivateEndpoints(tenantId, id): Observable<any> {
    return this.fabricService.invokeOperation<any>(SERVICE_NAME, 'delete_mgmt_tenants_tenantid_pe-connections_id', {tenantId, id});
  }

  syncPrivateEndpoints(tenantId, dataZone): Observable<any> {
    return this.fabricService.invokeOperation<any>(SERVICE_NAME, 'put_mgmt_tenants_tenantid_pe-connections_sync', {tenantId}, dataZone);
  }

}
